/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncS3ScanRequest
 */
export interface SyncS3ScanRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncS3ScanRequest
     */
    bucket: string;
    /**
     * 
     * @type {string}
     * @memberof SyncS3ScanRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SyncS3ScanRequest
     */
    version?: string;
}

/**
 * Check if a given object implements the SyncS3ScanRequest interface.
 */
export function instanceOfSyncS3ScanRequest(value: object): value is SyncS3ScanRequest {
    if (!('bucket' in value) || value['bucket'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function SyncS3ScanRequestFromJSON(json: any): SyncS3ScanRequest {
    return SyncS3ScanRequestFromJSONTyped(json, false);
}

export function SyncS3ScanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncS3ScanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': json['bucket'],
        'key': json['key'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function SyncS3ScanRequestToJSON(json: any): SyncS3ScanRequest {
    return SyncS3ScanRequestToJSONTyped(json, false);
}

export function SyncS3ScanRequestToJSONTyped(value?: SyncS3ScanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bucket': value['bucket'],
        'key': value['key'],
        'version': value['version'],
    };
}

